import React from "react";
const wineIcon = (
  <img
    alt="La Europea"
    className="card__icon border-right pr-2 mr-2"
    src={require("../../assets/icons/vino.svg")}
  />
);
const genericIcon = <img alt="E" className="card__icon border-right pr-2 mr-2" src={require('../../assets/icons/miscellaneous.svg')} />;
const giftIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const accesoriesIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const juiceIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const meatIcon = (
  <img alt="La Europea" src={require("../../assets/icons/meat.svg")} />
);
const fishIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const shrimpIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const beerIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const beerBottlesIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const whiskeyIcon = (
  <img
    alt="La Europea"
    className="card__icon border-right pr-2 mr-2"
    src={require("../../assets/icons/whiskey.svg")}
  />
);
const chipsIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const mixerIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const champagneIcon = (
  <img
    alt="La Europea"
    className="card__icon border-right pr-2 mr-2"
    src={require("../../assets/icons/champagne-glasses.svg")}
  />
);
const plateIcon = (
  <img alt="La Europea" src={require("../../assets/icons/vino.svg")} />
);
const tequilaIcon = (
  <img
    alt="La Europea"
    className="card__icon border-right pr-2 mr-2"
    src={require("../../assets/icons/tequila.svg")}
  />
);
const rumIcon = (
  <img
    alt="La Europea"
    className="card__icon border-right pr-2 mr-2"
    src={require("../../assets/icons/ron.svg")}
  />
);

const categoryIcons = category => {
  let icon;
  switch (category) {
    case "VINO":
      icon = wineIcon;
      break;
    case "VINO TINTO":
      icon = wineIcon;
      break;
    case "VINO BLANCO":
      icon = wineIcon;
      break;
    case "WHISKY":
      icon = whiskeyIcon;
      break;
    case "CHAMPAGNE":
      icon = champagneIcon;
      break;
    case "RON":
      icon = rumIcon;
      break;
    case "TEQUILA":
      icon = tequilaIcon;
      break;
    case "":
      icon = wineIcon;
      break;
    default:
      icon = genericIcon;
      break;
  }
  return icon;
};
export default categoryIcons;
